module.exports = __webpack_public_path__ + "static/img/awards-bgi.2e84bf2c.jpg";